var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #80d4d4;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #00a9a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-4 {\n        fill: #bfeaea;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 600,
    cy: 600.18,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M826.45,774.39l7.86,7.86c17.88,17.88,18.78,45.59.92,62.74-17.17,17.88-45.78,17.88-63.66,0l-7.86-7.86-.72.71c10.73,17.16,8.58,40.76-6.44,55.78-15.02,15.02-37.9,17.16-55.78,5.72l-9.3,9.3c2.15,13.59-2.15,27.17-12.87,37.19-15.02,15.02-37.9,17.16-54.35,7.15-15.02,3.58-30.75,3.58-45.77.72l-4.35-1.31-201.6-178.9-18.59-18.59c-42.19-42.19-42.19-110.13,0-152.32l118-118.71-117.86,118.59,118-118.71c8.58-9.3,13.13-21.02,14.49-32.47,2.86,2.86,6.96,5.29,10.54,7.44,22.88,13.59,54.35,10.01,74.37-10.01l45.77-45.77,7.15-7.15,11.44,11.44,19.31,20.02c16.45,16.45,19.39,40.87,5.08,58.75l166.22,288.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.32,486.84l-150.66,150.66c-24.15,24.15-63.83,24.15-87.98,0l-90.86-90.86,238.64-238.64,90.86,90.86c14.38,14.38,20.13,33.93,17.25,52.33-1.44,11.79-6.04,23.29-14.66,32.49-.57,1.15-1.72,2.3-2.59,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M845.94,754.89l-19.49,19.49-163.49-163.49-94.81,94.83c-17.83,17.83-46.3,17.54-64.13-.29l-31.63-31.63,161.4-161.39,79.61-79.61c-.93,6.11-.92,12.3.03,18.38,1.43,11.79,6.02,23.28,14.66,32.49.58,1.14,1.71,2.29,2.58,3.16l115.54,115.54c42.2,42.2,41.92,110.32-.27,152.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1060.18,546.64l-90.86,90.86c-24.16,24.14-63.83,24.16-87.99,0l-35.12-35.12-115.54-115.54c-.87-.86-2-2.02-2.58-3.16-8.64-9.21-13.23-20.7-14.66-32.49-.95-6.07-.97-12.27-.03-18.38,1.88-12.37,7.64-24.31,17.27-33.95l90.86-90.86,8.35,8.33,230.31,230.31Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 763.7,
    y1: 837.13,
    x2: 762.98,
    y2: 837.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 700.77,
    y1: 899.34,
    x2: 691.47,
    y2: 908.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.71,813.15l-31.91,31.91c-17.7,17.7-46.26,17.57-63.83,0-17.57-17.57-17.7-46.13,0-63.83l31.91-31.91c17.57-17.57,46.26-17.57,63.83,0,17.57,17.57,17.57,46.26,0,63.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.3,861.44l-31.91,31.91c-17.7,17.7-46.26,17.57-63.83,0-17.57-17.57-17.7-46.13,0-63.83l31.91-31.91c17.57-17.57,46.26-17.57,63.83,0,17.57,17.57,17.57,46.26,0,63.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.06,914.08l-31.91,31.91c-17.7,17.7-46.26,17.57-63.83,0-17.57-17.57-17.7-46.13,0-63.83l31.91-31.91c17.57-17.57,46.26-17.57,63.83,0,17.57,17.57,17.57,46.26,0,63.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.3947670f83a2f18b1795be57229707b6.svg";
export { ForwardRef as ReactComponent };